import { get_token } from "@/router";
import { handle_notification_realtime } from "@/services/notificationRealtimeHandlers";

export default {
    data() {
        return ({
            notifications: [],
            user_id: null,
            isLoading: false,
            isMarkingAllRead: false,
            isClearingNotifications: false,
            token_exists: false,
            unreadCount: 0,
            dropdown_id: `notification_dropdown_${Math.random().toString(36).slice(2)}`,
            offcanvas_id: `notification_offcanvas_${Math.random().toString(36).slice(2)}`,
        });
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        if (this.user_id && this.token_exists) {
            this.fetch_notifications();
        }

        this._realtime_event_handler = (event) => this.handle_realtime_event(event);
        this._realtime_connected_handler = () => this.handle_realtime_connected();
        window.addEventListener("realtime:event", this._realtime_event_handler);
        window.addEventListener("realtime:connected", this._realtime_connected_handler);
    },
    beforeUnmount() {
        if (this._realtime_event_handler) {
            window.removeEventListener("realtime:event", this._realtime_event_handler);
            this._realtime_event_handler = null;
        }
        if (this._realtime_connected_handler) {
            window.removeEventListener("realtime:connected", this._realtime_connected_handler);
            this._realtime_connected_handler = null;
        }
    },
    methods: {
        get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },
        
        getToken() {
            return get_token();
        },

        handle_realtime_event(event) {
            handle_notification_realtime(this, event);
        },

        handle_realtime_connected() {
            this.user_id = this.get_user_id();
            this.token_exists = Boolean(this.getToken());

            if (this.user_id && this.token_exists) {
                this.fetch_notifications();
            }
        },

        fetch_notifications() {
            if (!this.user_id || !this.getToken()) return;
            this.isLoading = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_notification/`,
                method: 'GET',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: { user_id: this.user_id },
                success: (response) => {
                    if (response.status === "success") {
                        this.notifications = response.notifications;
                        this.unreadCount = response.unread_count;
                    }
                },
                complete: () => {
                    this.isLoading = false;
                }
            });
        },

        format_date(date) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return new Date(date).toLocaleDateString(undefined, options);
        },
        notification_read(notification) {
            if (notification.is_read) return;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/mark_notifications_as_read/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    notification_id: notification.id
                }),
                success: (response) => {
                    if (response.status === "success") {
                        // update UI immediately
                        notification.is_read = true;

                        if (this.unreadCount > 0) {
                            this.unreadCount--;
                        }
                    }
                },
                error: (err) => {
                    console.error("Error marking notification as read", err);
                }
            });
        },

        mark_all_notifications_as_read() {
            if (this.unreadCount === 0 || this.isMarkingAllRead) return;

            this.isMarkingAllRead = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/mark_notifications_as_read/`,
                method: 'POST',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    mark_all: true
                }),
                success: (response) => {
                    if (response.status === "success") {
                        this.notifications = this.notifications.map(notification => ({
                            ...notification,
                            is_read: true
                        }));
                        this.unreadCount = 0;
                    }
                },
                error: (err) => {
                    console.error("Error marking all notifications as read", err);
                },
                complete: () => {
                    this.isMarkingAllRead = false;
                }
            });
        },

        delete_notification(notification) {
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_notification/`,
                method: 'DELETE',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    notification_id: notification.id
                }),
                success: (response) => {
                    if (response.status === "success") {
                        this.notifications = this.notifications.filter(
                            n => n.id !== notification.id
                        );

                        if (!notification.is_read && this.unreadCount > 0) {
                            this.unreadCount--;
                        }
                    }
                },
                error: (err) => {
                    console.error("Error deleting notification", err);
                }
            });
        },

        clear_all_notifications() {
            if (this.notifications.length === 0 || this.isClearingNotifications) return;

            this.isClearingNotifications = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_notification/`,
                method: 'DELETE',
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify({
                    clear_all: true
                }),
                success: (response) => {
                    if (response.status === "success") {
                        this.notifications = [];
                        this.unreadCount = 0;
                    }
                },
                error: (err) => {
                    console.error("Error clearing notifications", err);
                },
                complete: () => {
                    this.isClearingNotifications = false;
                }
            });
        },

        async handle_notification_click(notification) {

            // If not read → mark as read first
            if (!notification.is_read) {
                try {
                    await this.notification_read(notification)
                } catch (e) {
                    console.error("Failed to mark as read", e)
                }
            }

            // Then redirect
            if (notification.redirect_url) {
                window.location.href = notification.redirect_url
            }
        }

    }
};
